import type { FC, ReactNode } from "react";
import { formatData } from "./AutoCarousel.utils";
import { classNames } from "../../shared/lib/classNames";
import useAutoCarousel from "./useAutoCarousel";

import Style from "./AutoCarousel.module.sass";

interface AutoCarouselProps {
    data: Array<{ id: string; node: ReactNode }>;
    className?: string;
    duration?: number;
    playbackRate?: number;
    additionalClasses?: { slideClass?: string; cardClass?: string } | null;
}

const AutoCarousel: FC<AutoCarouselProps> = ({
    className,
    data,
    duration = 130,
    playbackRate = 0.5,
    additionalClasses = null,
}) => {
    const { handleStart, handleStopped, transform, containerRef, firstElemRef, secondElemRef } = useAutoCarousel({
        playbackRate,
        duration,
    });

    const slides = formatData(data).map(({ id, node }) => (
        <div
            key={id}
            className={classNames({
                cls: Style.slide,
                additional: [additionalClasses?.slideClass],
            })}
        >
            <div className={additionalClasses?.cardClass}>{node}</div>
        </div>
    ));

    return (
        <div
            ref={containerRef}
            className={classNames({
                cls: Style.container,
                additional: [className],
            })}
            onMouseOver={handleStopped}
            onFocus={handleStopped}
            onMouseLeave={handleStart}
            data-component="auto-carousel"
        >
            <div className={Style.slider} ref={firstElemRef} style={{ transform }}>
                {slides}
            </div>

            <div className={Style.slider} ref={secondElemRef}>
                {slides}
            </div>
        </div>
    );
};

export default AutoCarousel;
